const sampleDevKey = 'eyJhcGlLZXkiOiIiLCJhdXRoRG9tYWluIjoiIiwicHJvamVjdElkIjoiIiwic3RvcmFnZUJ1Y2tldCI6IiIsIm1lc3NhZ2luZ1NlbmRlcklkIjoiIiwiYXBwSWQiOiIiLCJtZWFzdXJlbWVudElkIjoiIn0=';

const firebaseConfig = JSON.parse(atob(import.meta.env.VITE_APP_FIREBASE_CONFIG ?? sampleDevKey));

export default firebaseConfig;
